import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MsalInterceptor, MsalGuard, MsalModule } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { ENVIRONMENT, LibCoreSharedModule, GlobalErrorHandler } from 'lib-core-shared';
import { LibUiSharedModule } from 'lib-ui-shared';
import { environment } from '../environments/environment';

import { ProductDetailResolver } from './resolver/product-data-resolver';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ProductCreateModule } from './containers/product-create/product-create.module';
import { AuthorisationErrorPageComponent } from './containers/errors/authorisation-error-page/authorisation-error-page.component';
import { RedirectToModule } from './containers/redirect-to/redirect-to.module';
const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

const getClientId = () => {
  return environment.clientId;
}
@NgModule({
  declarations: [
    AppComponent,
    AuthorisationErrorPageComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    LibUiSharedModule,
    LibCoreSharedModule,
    ProductCreateModule,
    MsalModule.forRoot(new PublicClientApplication({
      auth: {
        clientId: environment.clientId,
        authority: `${environment.cloudInstanceId}/${environment.tennantId}`,
        redirectUri: environment.redirectUri + '/assets/msal-auth-redirect.html' //we use an external html file otherwise angulars router modifies the MSAL hash which breaks it. See https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/a94db43e8b50fd831b82bb4c5a27422c07a63b12/lib/msal-browser/docs/errors.md#hash_empty_error
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
      },
      system: {
        allowRedirectInIframe: true
      }
    })
   , {
    interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [
          `api://${getClientId()}/access_as_user`
        ]
      },
      loginFailedRoute: 'products/auth-redirect'
    }
    , {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: new Map([
        [`${environment.apiUrl}/products`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/products/*.*`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/products/*.*/*.*`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/Products`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/Products/*.*`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/Products/*.*/*.*`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/Options`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/Options/*.*`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/productTypes`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/brands`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/attributes`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/Products/commonAttributes`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/ProductTags`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/ProductTags/*.*`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/ProductTags/*.*/*.*`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/Skunity`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/Skunity/*.*`, [ `api://${environment.clientId}/access_as_user`]],
        [`${environment.apiUrl}/Skunity/*.*/*.*`, [ `api://${environment.clientId}/access_as_user`]]
      ])
    }),
  ],
  providers: [
    { provide: ENVIRONMENT, useValue: environment },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    MsalGuard,
    ProductDetailResolver,
    { provide: ErrorHandler, useClass: GlobalErrorHandler},
    RedirectToModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
